module.exports = __webpack_public_path__ + "static/img/header.a65ecdd.png";


//////////////////
// WEBPACK FOOTER
// ./static/client/header.png
// module id = kYTF
// module chunks = 1